import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { patchDetailsForImageSlider } from 'redux/image-sliders/actions';

import CommonTextInput from
    'components/elements/inputs/CommonTextInput';

import './CommonSliderImageDetails.css';

const CommonSliderImageDetails = props => {
  const { item, patchDetailsForImageSlider, patchDetailsForImageSliderError } = props;
  const { t } = useTranslation();

  const changeValue = (parameter, value) => {
    const form = new FormData();
    form.append(parameter, value);
    patchDetailsForImageSlider(item.id, form);
  };

  const fieldValidation = value => {
    const errors = [];
    if (value && value.length > 128) {
      errors.push(t("Ensure this field has no more than 128 characters"));
    }
    return errors;
  };

  const urlValidation = value => {
    const errors = [];
    const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if (!regex.test(value)) {
      errors.push(t('Please enter a valid url'));
    }
    return errors;
  };

  return (
    <div className="common-slider-image-details__component">
      {/* Title */}
      <CommonTextInput
        key={`common-slider-image-details-title-input-key-${item.id}`}
        label={t("Title")}
        placeholder={t("Image Title")}
        initValue={item.title}
        executedFunction={value => { changeValue('title', value); }}
        validationErrors={value => { return fieldValidation(value); }}
        actionErrors={patchDetailsForImageSliderError && patchDetailsForImageSliderError.title}
      />

      {/* Description */}
      <CommonTextInput
        key={`common-slider-image-details-descr-input-key-${item.id}`}
        label={t("Description")}
        placeholder={t("Image Description")}
        initValue={item.description}
        executedFunction={value => { changeValue('description', value); }}
        validationErrors={value => { return fieldValidation(value); }}
        actionErrors={patchDetailsForImageSliderError && patchDetailsForImageSliderError.description}
      />

      {/* Link Text */}
      <CommonTextInput
        key={`common-slider-image-details-link-text-input-key-${item.id}`}
        label={t("Link Text")}
        placeholder={t("Image Link Text")}
        initValue={item.link_text}
        executedFunction={value => { changeValue('link_text', value); }}
        validationErrors={value => { return fieldValidation(value); }}
        actionErrors={patchDetailsForImageSliderError && patchDetailsForImageSliderError.link_text}
      />

      {/* Link Url */}
      <CommonTextInput
        key={`common-slider-image-details-link-url-input-key-${item.id}`}
        label={t("Link URL")}
        placeholder={t("Image Link URL")}
        initValue={item.link_url}
        executedFunction={value => { changeValue('link_url', value); }}
        validationErrors={value => { return urlValidation(value); }}
        actionErrors={patchDetailsForImageSliderError && patchDetailsForImageSliderError.link_url}
      />
    </div>
  );
};

CommonSliderImageDetails.propTypes = {
  patchDetailsForImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  patchDetailsForImageSliderError: PropTypes.object,
};

CommonSliderImageDetails.defaultProps = {
  patchDetailsForImageSliderError: null,
};

const mapStateToProps = state => (
  {
    patchDetailsForImageSliderError: state.imageSlidersReducer.patchDetailsForImageSliderError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchDetailsForImageSlider,
  },
)(CommonSliderImageDetails);
